import {BaseContainerModel} from '../base-container.model';
import { bl_applet_event_RowClass } from '../../dbschema';

export class AppletEventContainerModel extends BaseContainerModel {
  bl_applet_event: bl_applet_event_RowClass = new bl_applet_event_RowClass();
}
